window.addEventListener('DOMContentLoaded', function () {
	const alert_banners = document.querySelectorAll('.alert-banner');
	const dismissed_banners =
		JSON.parse(localStorage.getItem('dismissed_banners')) || [];
	// Create a close button to inject into all notifications.
	const close_button = document.createElement('button');
	close_button.setAttribute('type', 'button');
	close_button.setAttribute('aria-label', 'Close alert');
	close_button.classList.add('alert-banner_close');
	close_button.innerHTML =
		'<svg viewBox="0 0 24 24"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path></svg>';

	for (const alert_banner of alert_banners) {
		const banner_content = alert_banner.textContent.trim();

		if (dismissed_banners.includes(banner_content)) {
			alert_banner.remove();
			continue;
		}
		// For each alert banner, insert the close button into the first child
		// 'kt-inside-inner-col' element and make it hide the alert_banner it is inside of.
		const close_button_clone = close_button.cloneNode(true);
		const inner_col = alert_banner.querySelector('.kt-inside-inner-col');

		if (inner_col) {
			inner_col.style.position = 'relative';
			inner_col.appendChild(close_button_clone);
			close_button_clone.addEventListener('click', function () {
				const banner_content = alert_banner.textContent.trim();
				const dismissed_banners =
					JSON.parse(localStorage.getItem('dismissed_banners')) || [];
				dismissed_banners.push(banner_content);
				localStorage.setItem(
					'dismissed_banners',
					JSON.stringify(dismissed_banners)
				);
				alert_banner.remove();
			});
		}
		alert_banner.classList.add('--initialized');
	}
});
